module.exports = __webpack_public_path__ + "static/media/color-theme-icon.5f109305.svg";